import {grid, gridItem} from '~/design-system/foundations'
import {HgLogoMash} from '../../components/HgLogoMash'

export type Logo = {
  logo: React.ReactNode
  companyName: string
  captionText?: string
}

export type HgLogoMashProps = {
  logos: [Logo, Logo, Logo, Logo, ...Logo[]]
  title?: string | React.ReactNode
}

export function HgLogoMashModule(props: HgLogoMashProps) {
  const {logos, title} = props

  return (
    <div className={grid({className: 'mx-auto'})}>
      {title && (
        <p
          className={gridItem({
            size: 'heading',
            className: 'mt-s9 text-center text-text-default arcadia-subheading-5',
          })}
        >
          {title}
        </p>
      )}
      <div className={gridItem({size: 'max', className: 'mt-s6'})}>
        <HgLogoMash logos={logos} />
      </div>
    </div>
  )
}
